import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { MapOtpimizationModel, WayPoints } from 'src/app/Model/Shipping/map-otpimization-model';
import { MapOptimizedResponse } from 'src/app/Model/Shipping/map-optimized-response';
import { ShippingSequanceData } from 'src/app/Model/Shipping/shipping-sequance-data';
import { RouteAsPerMap } from 'src/app/Model/Shipping/route-as-per-map';
import { Constant } from 'src/app/Common/constant';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { Location } from 'src/app/Model/Shipping/location';
import { DistanceAndWeather } from 'src/app/Model/Shipping/way-point';
import { ConfirmationDialogComponent } from 'src/app/Base/confirmation-dialog/confirmation-dialog.component';


@Component({
  selector: 'shipping-start',
  templateUrl: './shipping-start.component.html',
  styleUrls: ['./shipping-start.component.css']
})
export class ShippingStartComponent implements OnInit, OnDestroy {

  pickedUpShippingData: AllDeliveryDetailsDto[] = [];
  storeLocation: Location = new Location();
  employeeCode: string;
  mapOtpimizationModel: MapOtpimizationModel = new MapOtpimizationModel();
  mapOptimizedResponse: MapOptimizedResponse[] = [];
  shippingSequanceData: ShippingSequanceData[] = [];
  routeAsPerMap: RouteAsPerMap[] = [];
  constant: Constant = new Constant();
  errorLog: ErrorLog = new ErrorLog();
  companyCode: number

  //Subscription
  private getLocationSubscription: Subscription;
  private getOptimizeRouteSubscription: Subscription;
  private saveSequenceDataSubscription: Subscription;
  private saveRouteDetailsSubscription: Subscription;
  private getTrafficDetailsDetailsSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<ShippingStartComponent>,
    public dialog: MatDialog,
    private apiFactory: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private shippingManagerService: ShippingManagerService,
  ) {
    dialogRef.disableClose = true;
    this.employeeCode = JSON.parse(this.persistenceService.get("google_email"));
    // this.companyCode = JSON.parse(this.persistenceService.get('userDetail')).company.refNo;
    // this.companyCode = 1;
    // this.employeeCode = '0001-6';
    this.pickedUpShippingData = dialogData.shippingData;
  }

  ngOnInit(): void {
    this.getLocationById();
  }

  ngOnDestroy() {
    if (this.getLocationSubscription !== undefined)
      this.getLocationSubscription.unsubscribe();

    if (this.getOptimizeRouteSubscription !== undefined)
      this.getOptimizeRouteSubscription.unsubscribe();

    if (this.saveSequenceDataSubscription !== undefined)
      this.saveSequenceDataSubscription.unsubscribe();

    if (this.saveRouteDetailsSubscription !== undefined)
      this.saveRouteDetailsSubscription.unsubscribe();

    if (this.getTrafficDetailsDetailsSubscription !== undefined)
      this.getTrafficDetailsDetailsSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getLocationById() {
    this.getLocationSubscription = this.shippingManagerService.getLocationById(this.apiFactory.getLocationById, this.pickedUpShippingData[0].locationCode).subscribe((data) => {
      this.storeLocation = data;
      this.companyCode = this.storeLocation.parentCompanyCode;
      // this.getOptimizedRouteResult();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getLocationById", error);
      });
  }

  getOptimizedRouteResult() {
    let headingMessage = this.constant.startRideData;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '23%',
      width: '346px',
      data: { heading: headingMessage }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.mapOtpimizationModel.startLocationName = this.storeLocation.locationName;
        this.mapOtpimizationModel.startLatitude = Number(this.storeLocation.latitude.trim());
        this.mapOtpimizationModel.startLongitude = Number(this.storeLocation.longitude.trim());
        this.mapOtpimizationModel.finishLocationName = this.storeLocation.locationName;
        this.mapOtpimizationModel.finishLatitude = Number(this.storeLocation.latitude.trim());
        this.mapOtpimizationModel.finishLongitude = Number(this.storeLocation.longitude.trim());
        this.mapOtpimizationModel.circularDirection = false;
        this.mapOtpimizationModel.requiredTrafficAndWeatherData = true;
        this.mapOtpimizationModel.companyCode = this.companyCode;

        let wayPoints: WayPoints[] = [];
        this.pickedUpShippingData.forEach(element => {
          if (element.customerDeliveryDetails.latitude && element.customerDeliveryDetails.latitude) {
            let point: WayPoints = new WayPoints();
            point.latitude = Number(element.customerDeliveryDetails.latitude.toString().trim());
            point.longitude = Number(element.customerDeliveryDetails.longitude.toString().trim());
            wayPoints.push(point);
          }
        })
        this.mapOtpimizationModel.wayPoints = wayPoints;

        if (this.mapOtpimizationModel.wayPoints.length > 1) {
          this.getOptimizeRouteSubscription = this.shippingManagerService.getOptimizeRoute(this.apiFactory.getOptmizedMapDetailsWithTrafficAndWeather, this.mapOtpimizationModel).subscribe((data: any) => {
            console.log(data)
            if (data.length > 0) {
              this.mapOptimizedResponse = data;
              this.onConfirmClick();
            }
            // else {
            //   this.onConfirmClick();
            // }
          },
            (error: HttpErrorResponse) => {
              this.insertErrorLog("getOptimizedRouteResult", error);
            });
        }
        else {
          this.onConfirmClick();
        }
      }
    })
  }

  onConfirmClick() {
    let sequanceDataList: ShippingSequanceData[] = [];
    if (this.mapOptimizedResponse.length > 0) {
      this.mapOptimizedResponse.forEach(element => {
        this.pickedUpShippingData.forEach((item, index) => {
          let point: ShippingSequanceData = new ShippingSequanceData();
          if (element.actualSeqNo == index) {
            point.employeeCode = this.employeeCode;
            point.transactionNo = item.assignedDeliveryDto.invNo;
            point.actualSeqNo = element.actualSeqNo;
            point.seqNo = element.seqNo;
            point.fromLocationName = element.fromLocationName;
            point.fromLatitude = element.fromLatitude;
            point.fromLongitude = element.fromLongitude;
            point.toLocationName = element.toLocationName;
            point.toLatitude = element.toLatitude;
            point.toLongitude = element.toLongitude;
            sequanceDataList.push(point);
          }
        })
      })
    } else {
      this.pickedUpShippingData.forEach((item, index) => {
        let point: ShippingSequanceData = new ShippingSequanceData();
        point.employeeCode = this.employeeCode;
        point.transactionNo = item.assignedDeliveryDto.invNo;
        point.actualSeqNo = index;
        point.seqNo = index + 1;
        point.fromLocationName = this.storeLocation.locationName;
        point.fromLatitude = Number(this.storeLocation.latitude.trim());
        point.fromLongitude = Number(this.storeLocation.longitude.trim());
        point.toLocationName = item.customerDeliveryDetails.shippingAddress;
        point.toLatitude = Number(item.customerDeliveryDetails.latitude.toString().trim());
        point.toLongitude = Number(item.customerDeliveryDetails.longitude.toString().trim());
        sequanceDataList.push(point);
      })
    }

    this.saveSequenceDataSubscription = this.shippingManagerService.saveSequenceData(this.apiFactory.insertShippingSequenceData, sequanceDataList).subscribe((data: any) => {
      if (data.length > 0) {
        this.shippingSequanceData = data;
        this.setRouteDetailsAsPerMap();
        // this.dialogRef.close(this.shippingSequanceData);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onConfirmClick", error);
      });
  }

  setRouteDetailsAsPerMap() {
    // Initialize an empty array to hold the route details
    let routeDetailsList: RouteAsPerMap[] = [];
    let previousToLocCode: string | null = null;
    let firstFromLocCode: string | null = null;

    // If there is no data in mapOptimizedResponse, call getTrafficDetails and exit the method
    // if (this.mapOptimizedResponse.length === 0) {
    //   return;
    // }

    if (this.mapOptimizedResponse.length > 0) {
      // Iterate through each element in mapOptimizedResponse
      this.mapOptimizedResponse.forEach(element => {
        // Nested loop through pickedUpShippingData
        this.pickedUpShippingData.forEach((item, index) => {
          // Only process if the actual sequence number matches the current index
          if (element.actualSeqNo !== index) return;

          // Create a new RouteAsPerMap instance and populate its properties
          let point: RouteAsPerMap = new RouteAsPerMap();
          point.onDateTime = moment().format("yyyy-MM-DD HH:mm:ss");
          point.serviceManID = item.assignedDeliveryDto.serviceManCode;
          point.weatherCondition = element.weatherCondition;
          point.trafficCondition = element.trafficCondition;
          point.trafficDuration = element.trafficDuration.toString();
          point.distance = element.distance.toString();
          point.duration = element.trafficDuration.toString();

          // Assign fromLocCode, use previousToLocCode if available, otherwise use item.locationCode
          point.fromLocCode = previousToLocCode || item.locationCode.toString();

          // Assign the current toLocCode
          point.toLocCode = item.customerDeliveryDetails.refNo.toString();
          point.usedFor = "Shipping Management";
          point.usedForRefNo = item.assignedDeliveryDto.invNo;
          point.deliverySequenceNo = element.seqNo;

          // Add the current point to the routeDetailsList
          routeDetailsList.push(point);

          // Update previousToLocCode for the next iteration
          previousToLocCode = point.toLocCode;

          // Store the first fromLocCode for use in the extra data point later
          if (!firstFromLocCode) {
            firstFromLocCode = point.fromLocCode;
          }
        });
      });
    }
    else {
      this.getTrafficDetails();
    }

    // After looping through all data, check if we have valid fromLocCode and toLocCode for the extra point
    if (previousToLocCode && firstFromLocCode) {
      // Create the extra point that represents the return to the starting location
      let extraPoint = this.createExtraPoint(previousToLocCode, firstFromLocCode);

      // Add the extra point and fetch its traffic details
      this.addReturnToParent(routeDetailsList, extraPoint);
    }
  }

  // Helper method to create an extra RouteAsPerMap object for the return trip
  createExtraPoint(fromLocCode: string, toLocCode: string): RouteAsPerMap {
    let extraPoint = new RouteAsPerMap();
    extraPoint.onDateTime = moment().format("yyyy-MM-DD HH:mm:ss");
    extraPoint.serviceManID = this.pickedUpShippingData[0].assignedDeliveryDto.serviceManCode; // Assuming the first service man is used
    extraPoint.fromLocCode = fromLocCode;
    extraPoint.toLocCode = toLocCode;
    extraPoint.usedFor = "Shipping Management";
    // extraPoint.usedForRefNo = "Return To Parent";
    extraPoint.deliverySequenceNo = 0; // Set as needed

    return extraPoint;
  }

  // Method to add the extra point to the list and fetch traffic details for it
  addReturnToParent(routeDetailsList: RouteAsPerMap[], extraPoint: RouteAsPerMap) {
    let fromLat;
    let fromLng;
    // Get the latitude and longitude for the last point and the store location
    if (this.mapOptimizedResponse.length > 0) {
      const lastElement = this.mapOptimizedResponse[this.mapOptimizedResponse.length - 1];
      fromLat = lastElement.toLatitude.toString().trim();
      fromLng = lastElement.toLongitude.toString().trim();
    }
    else {
      fromLat = this.pickedUpShippingData[0].customerDeliveryDetails.latitude.toString().trim();
      fromLng = this.pickedUpShippingData[0].customerDeliveryDetails.longitude.toString().trim();
    }
    const toLat = this.storeLocation.latitude.trim();
    const toLng = this.storeLocation.longitude.trim();

    // Make an API call to get traffic details for the return trip
    this.getTrafficDetailsDetailsSubscription = this.shippingManagerService.getTrafficDetails(this.apiFactory.getTrafficDetails, fromLat, fromLng, toLat, toLng, "Yes", this.companyCode).subscribe(
      (data: DistanceAndWeather) => {
        // If the API call is successful, populate the extra point with the data
        if (data) {
          extraPoint.weatherCondition = data.weather;
          extraPoint.trafficCondition = data.trafficCondition;
          extraPoint.trafficDuration = data.trafficDuration.toString();
          //Making 50% off on return distance
          extraPoint.distance = data.distance.toString();
          // extraPoint.distance = (data.distance / 2).toString();
          extraPoint.duration = data.trafficDuration.toString();
          extraPoint.usedForRefNo = "Return To Parent_" + routeDetailsList[routeDetailsList.length - 1].usedForRefNo;

          // Add the extra point to the routeDetailsList
          routeDetailsList.push(extraPoint);

          // Save the final route details list
          this.saveRouteDetailsAsPerMap(routeDetailsList);
        }
      },
      (error: HttpErrorResponse) => {
        // Log any errors that occur during the API call
        this.insertErrorLog("getTrafficDetails", error);
      }
    );
  }

  setRouteDetailsAsPerMap1() {
    let routeDetailsList: RouteAsPerMap[] = [];
    if (this.mapOptimizedResponse.length > 0) {
      this.mapOptimizedResponse.forEach(element => {
        this.pickedUpShippingData.forEach((item, index) => {
          let point: RouteAsPerMap = new RouteAsPerMap();
          if (element.actualSeqNo == index) {
            point.onDateTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
            point.serviceManID = item.assignedDeliveryDto.serviceManCode;
            point.weatherCondition = element.weatherCondition;
            point.trafficCondition = element.trafficCondition;
            point.trafficDuration = element.trafficDuration.toString();
            point.distance = element.distance.toString();
            point.duration = element.trafficDuration.toString();
            point.fromLocCode = item.locationCode.toString();
            point.toLocCode = item.customerDeliveryDetails.refNo.toString();
            point.usedFor = "Shipping Management";
            point.usedForRefNo = item.assignedDeliveryDto.invNo;
            point.deliverySequenceNo = element.seqNo;
            routeDetailsList.push(point);
          }
        })
      })
      this.saveRouteDetailsAsPerMap(routeDetailsList);
    }
    else {
      this.getTrafficDetails();
    }
  }

  saveRouteDetailsAsPerMap(routeDetailsList: RouteAsPerMap[]) {
    console.log(routeDetailsList);

    // Update shippingSequanceData with fromLocCode and toLocCode
    this.shippingSequanceData.forEach(shippingItem => {
      const matchingRoute = routeDetailsList.find(route => route.usedForRefNo === shippingItem.transactionNo);
      if (matchingRoute) {
        shippingItem.fromLocCode = matchingRoute.fromLocCode;
        shippingItem.toLocCode = matchingRoute.toLocCode;
      }
    });

    console.log("Updated shippingSequanceData:", this.shippingSequanceData);

    // Save the route details
    this.saveRouteDetailsSubscription = this.shippingManagerService.saveRouteDetails(this.apiFactory.saveRouteDetailsAsPerMap, routeDetailsList).subscribe((data: any) => {
      console.log(data);
      // Pass updated shippingSequanceData to dialog close
      this.dialogRef.close(this.shippingSequanceData);
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("saveRouteDetailsAsPerMap", error);
      });
  }

  getTrafficDetails() {
    let fromLat: string = this.storeLocation.latitude.trim();
    let fromLng: string = this.storeLocation.longitude.trim();
    let toLat: string = this.pickedUpShippingData[0].customerDeliveryDetails.latitude.toString().trim();
    let toLng: string = this.pickedUpShippingData[0].customerDeliveryDetails.longitude.toString().trim();
    let companyCode: number = this.companyCode;

    let routeDetailsList: RouteAsPerMap[] = [];
    let previousToLocCode: string | null = null;
    let firstFromLocCode: string | null = null;

    this.getTrafficDetailsDetailsSubscription = this.shippingManagerService.getTrafficDetails(this.apiFactory.getTrafficDetails, fromLat, fromLng, toLat, toLng, "Yes", companyCode).subscribe((data: DistanceAndWeather) => {
      console.log(data)
      if (data) {
        // let routeDetailsList: RouteAsPerMap[] = [];
        this.pickedUpShippingData.forEach((item, index) => {
          let point: RouteAsPerMap = new RouteAsPerMap();
          point.onDateTime = moment(new Date()).format("yyyy-MM-DD HH:mm:ss");
          point.serviceManID = item.assignedDeliveryDto.serviceManCode;
          point.weatherCondition = data.weather;
          point.trafficCondition = data.trafficCondition;
          point.distance = data.distance.toString();
          point.duration = data.trafficDuration.toString();
          point.fromLocCode = item.locationCode.toString();
          point.toLocCode = item.customerDeliveryDetails.refNo.toString();
          point.usedFor = "Shipping Management";
          point.usedForRefNo = item.assignedDeliveryDto.invNo;
          point.deliverySequenceNo = index + 1;
          routeDetailsList.push(point);

          previousToLocCode = point.toLocCode;
          if (!firstFromLocCode) {
            firstFromLocCode = point.fromLocCode;
          }

          if (previousToLocCode && firstFromLocCode) {
            let extraPoint = this.createExtraPoint(previousToLocCode, firstFromLocCode);
            this.addReturnToParent(routeDetailsList, extraPoint);
          }
        })
        // this.saveRouteDetailsAsPerMap(routeDetailsList);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTrafficDetails", error);
      });
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }
}
